import * as React from 'react'

function SvgPlayerVolume(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M11.827 5.106c.39-.278.912.022.912.523v12.742c0 .501-.522.8-.912.523l-5.128-4.379H4.587c-.325 0-.587-.282-.587-.629v-3.772c0-.347.262-.629.587-.629h2.112zM13.809 6a5.934 5.934 0 015.677 5.92 5.932 5.932 0 01-5.677 5.92.244.244 0 01-.248-.241v-1.295c0-.123.097-.218.22-.224a4.171 4.171 0 003.945-4.16 4.17 4.17 0 00-3.945-4.159.227.227 0 01-.22-.225V6.242c0-.134.115-.248.248-.242zm-.118 3.388a2.536 2.536 0 010 5.064c-.091 0-.13-.055-.13-.12v-1.526c0-.059.038-.103.106-.117a.772.772 0 00.668-.769.773.773 0 00-.668-.768c-.068-.013-.106-.059-.106-.118V9.51c0-.065.039-.12.13-.12z" />
    </svg>
  )
}

export default SvgPlayerVolume
